import { useNavigate } from "react-router-dom";
import { useAuthContext, useLanguageContext } from "../../../../../context";
import { useCompany } from "../../../../../hooks";
import {
  CustomContainer,
  Loading,
  CreateCompanyComponent,
} from "../../../../common";

const EditCategories = () => {
  let navigate = useNavigate();

  const { I18n } = useLanguageContext();
  const { business, user } = useAuthContext();

  const { isLoading, company } = useCompany(business);

  return isLoading ? <Loading /> : <CreateCompanyComponent company={company} />;
};

export default EditCategories;
